import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import store from 'store';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Alert from 'react-s-alert';

import {
    Badge,
    Button,
    Col, Container, Row
} from 'reactstrap';

import PolyUtil from "../../../util/PolyUtil";
import ConfirmModal from "../../../components/display/Modals/ConfirmModal";
import {displayConfirmModal} from "../../../store/actions/display";
import {handleArchiveListing} from "../actions/owner";

class OwnerPropertyCard extends Component {
    state = {
        showPrivateTooltip: false,
        buttonDropdownOpen: false,
    };

    toggleConfirmModal = () => {
        this.props.displayConfirmModal({
            id: this.props.propId,
            acting: false,
            title: "Unlist: " + PolyUtil.getPropertyStreetAddress(this.props.property),
            body: "Are you sure you want to unlist this property? This can't be undone.",
            confirmText: "Unlist",
            confirmColor: "danger",
            onConfirm: () => this.props.archiveListing(this.props.propId, this.props.property.active_listing.id)
        });
    };

    togglePrivateTooltip = () => {
        this.setState({showPrivateTooltip: !this.state.showPrivateTooltip});
    };

    toggleButtonDropdownOpen = () => {
        this.setState({buttonDropdownOpen: !this.state.buttonDropdownOpen});
    };

    componentDidMount() {
        if (store.get('prop_id')) {
            const prop_id = store.get('prop_id');
            store.remove('prop_id');
            this.props.toggleAddListingModal(prop_id);
        }
    }

    content = () => {
        const {propId, toggleAddListingModal, property: {active_listing}} = this.props;
        let isListed = (active_listing && active_listing.rent && active_listing.security_deposit && active_listing.lease_length);
        let applyLink = this.props.property.active_listing ? this.props.property.active_listing.apply_key : "";

        const hasGroups = active_listing.applied_roommate_group_counts;
        const appliedGroups = hasGroups ? (active_listing.applied_roommate_group_counts.pending + active_listing.applied_roommate_group_counts.accepted) : 0;
        // const newGroups = hasGroups ? (active_listing.applied_roommate_group_counts.new) : 0;
        const pendingGroups = hasGroups ? (active_listing.applied_roommate_group_counts.pending) : 0;
        const acceptedGroups = hasGroups ? (active_listing.applied_roommate_group_counts.accepted) : 0;

        return (
            <Row className="d-flex justify-content-center my-auto">
                <Col className="center">
                    {
                        isListed ? (
                            <div>
                                {!active_listing.public && (<small id="privateFlag" className="text-info"><i className="fa fa-eye-slash"></i>{' Private'}</small>)}
                                <h4 className="mb-1" style={{color: '#374245'}}>Active Listing {' '}
                                    <span style={{fontSize: '60%', fontWeight: '300'}}>
                                        ({appliedGroups} Applications)
                                    </span>
                                </h4>
                                {/*hasGroups && active_listing.applied_roommate_group_counts.new !== 0 &&
                                    <Badge style={{margin: '5px'}} color="warning" pill>{newGroups} New!</Badge>
                                    Removing this until Alex figures out what the heck is going on with it.
                                */}
                                <Badge style={{margin: '5px'}} color={pendingGroups === 0 ? "secondary" : "warning"} pill>{pendingGroups} Triage</Badge>
                                <Badge style={{margin: '5px'}} color="success" pill>{acceptedGroups} Qualified</Badge>

                                <CopyToClipboard text={"https://polyrents.com/listings/" + applyLink}
                                                 onCopy={() => Alert.info("Copied to clipboard!")}>
                                    <p className="link-style mb-1">{"polyrents.com/listings/" + applyLink}</p>
                                </CopyToClipboard>

                                {/* <Tooltip placement="top"
                                         isOpen={this.state.showPrivateTooltip}
                                         target="privateFlag"
                                         toggle={this.togglePrivateTooltip}>
                                    This listing is only viewable with the link below
                                </Tooltip> */}
                            </div>
                        ) : (
                            <div style={{width: '100%'}}>
                                <div className="center">
                                    <h5 style={{color: '#374245'}}>Not Listed</h5>
                                    <Button outline color="secondary" onClick={() => {
                                        toggleAddListingModal(propId);
                                    }}>
                                        List Property
                                    </Button>
                                </div>
                            </div>
                        )
                    }
                </Col>
                {
                    isListed && (
                        <Col className="row justify-content-between align-items-center" style={{zIndex: "1000"}}>
                            <Container fluid>

                                <div>
                                    <Button block id="viewListingButton" color="info" outline tag={Link} to={"/listings/" + active_listing.apply_key + "/"}>View Listing</Button>
                                    {/*<ButtonGroup vertical size="sm" width="100%">*/}

                                    {/*<Button block id="editListingButton" color="info" className="text-left" outline><i className="fa fa-pencil"></i> Edit Listing</Button>*/}
                                    {/*<Button block id="inviteTenantButton" color="success" className="text-left" outline onClick={() => {toggleInviteTenantModal(propId)}}><i className="fa fa-paper-plane"></i> Invite Tenants</Button>*/}
                                    {/*</ButtonGroup>*/}
                                    <Button block id="unlistButton" color="danger" outline onClick={this.toggleConfirmModal}>Unlist</Button>
                                </div>

                            </Container>
                        </Col>
                    )
                }
                <ConfirmModal id={propId}/>

            </Row>
        );
    };

    render() {
        return PolyUtil.propsReady(this.props, ['propId', 'involvement', 'active_listing']) ? this.content() : null;
    }
}

const mapStateToProps = (state, props) => ({
    property: state.owner.properties.find((property) => {
        return property.id === props.propId;
    }),
    involvement: state.owner.involvement
});

const mapDispatchToProps = (dispatch) => {
    return {
        displayConfirmModal(id) {
            return dispatch(displayConfirmModal(id));
        },
        archiveListing(propId, listingId) {
            return dispatch(handleArchiveListing(propId, listingId));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OwnerPropertyCard);



// WEBPACK FOOTER //
// ./src/containers/owner/properties/OwnerPropertyCard.js